// 生成一个ID
// [参考](https://gist.github.com/gordonbrander/2230317)
// @constructor

// Generate unique IDs for use as pseudo-private/protected names.
// Similar in concept to
// <http://wiki.ecmascript.org/doku.php?id=strawman:names>.
//
// The goals of this function are twofold:
//
// * Provide a way to generate a string guaranteed to be unique when compared
//   to other strings generated by this function.
// * Make the string complex enough that it is highly unlikely to be
//   accidentally duplicated by hand (this is key if you're using `ID`
//   as a private/protected name on an object).
//
// Use:
//
//     let privateName = makeID();
//     let o = { 'public': 'foo' };
//     o[privateName] = 'bar';
export const makeID = () =>
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  `_${Math.random()
    .toString(36)
    .substr(2, 9)}`
// 事件总线
export class EventBus {
  _events

  _maxListeners

  constructor(maxListeners) {
    this._events = new Map()
    this._maxListeners = maxListeners || 10
  }

  on(type, fn) {
    const handler = this._events.get(type)
    if (!handler) {
      this._events.set(type, fn)
    } else if (handler && typeof handler === 'function') {
      // this._events.set(type, [handler, fn])
      // 只保留最新的一个fn
      this._events.set(type, [fn])
    } else {
      handler.push(fn)
      try {
        // 大于最大监听数量去除第一个
        if (handler.length > this._maxListeners) {
          handler.shift()
        }
      } catch (error) {}
    }
  }

  emit(type, ...args) {
    const handler = this._events.get(type)
    if (!handler) return false

    if (Array.isArray(handler)) {
      for (let i = 0; i < handler.length; i += 1) {
        if (args.length > 0) {
          handler[i].apply(this, args)
        } else {
          handler[i].call(this)
        }
      }
    } else if (args.length > 0) {
      handler.apply(this, args)
    } else {
      handler.call(this)
    }
    return true
  }

  off(type, fn) {
    const handler = this._events.get(type)

    if (handler && typeof handler === 'function') {
      this._events.delete(type, fn)
    } else {
      handler.splice(
        handler.findIndex(e => e === fn),
        1
      )
    }
  }
}
